import * as Yup from 'yup'

// add department:
export const createForm = {
    intialValues: {
        codigo: '',
        nombre: '',
        tasaIva: 0.0,
    },
    validationSchema: Yup.object({
        codigo: Yup.number().required('El codigo es requerido').min(1),
        nombre: Yup.string().required('El nombre es requerido'),
        tasaIva: Yup.number()
            .required('El iva es requerido')
            .min(0, 'El IVA no puede ser menor a 0'),
    }),
}

// update department:


export const initialValuesUpdate = (departamento) => ({
    nombre: departamento.nombre,
    tasaIva: departamento.tasaIva,
})

export const validationSchemaUpdate = Yup.object({
    nombre: Yup.string().required('Obligatorio'),
    tasaIva: Yup.number()
        .required('Obligatorio')
        .min(0, 'El IVA no puede ser menor a 0'),
})
